export const getTopics = (state) => state.topicState;
